import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { auth, db } from './firebase'
import store from './store'
import VueGtm from 'vue-gtm'

import './main.css'
import { UserData } from './store/profile/types'

Vue.config.productionTip = false

Vue.use(VueGtm, {
  id: 'GTM-MJK2LB',
  defer: false,
  enabled: true,
  debug: true,
  loadScript: true,
  vueRouter: router
})

let app: Vue

let start = Date.now()

auth.onAuthStateChanged(async (user) => {
  console.log(`auth state changed after ${Date.now() - start}ms`)
  // console.log(`user is ${JSON.stringify(user)}`)
  start = Date.now()

  // initialize app if not exists
  if (!app) {
    app = new Vue({
      router,
      store,
      created () {
        // do store initialization stuff
        this.$store.dispatch('data/setContactlenses')
        this.$store.dispatch('data/setShops')
      },
      render: h => h(App)
    }).$mount('#app')
    console.log(`initialized vue app: ${Date.now() - start}ms`)
    start = Date.now()
  }

  store.dispatch('profile/setUser', user)
  if (user && user.email) {
    // track login
    app.$gtm.trackEvent({
      event: 'login',
      providerId: user?.providerData[0]?.providerId
    })

    // if first login, fire initial login
    console.log('metadata: ' + JSON.stringify(user.metadata))
    if (user.metadata.creationTime === user.metadata.lastSignInTime) {
      console.log('fire initial login')
      app.$gtm.trackEvent({
        event: 'initialLogin',
        providerId: user?.providerData[0]?.providerId
      })
    }

    console.log('user found - check profile')
    await db.collection('users').doc(user.uid).get().then(async (doc) => {
      if (doc.exists) {
        console.log('load existing profile: ' + JSON.stringify(doc.data()))
        await store.dispatch('profile/updateUserData', doc.data())
      } else {
        console.log('else initialize empty profile')
        if (user && user.providerData[0] && user.providerData[0].displayName) {
          const displayName = user.providerData[0].displayName
          const data: UserData = new UserData()
          if (displayName.indexOf(' ') > 0) {
            data.firstname = displayName.substr(0, displayName.indexOf(' '))
            data.lastname = displayName.substr(displayName.indexOf(' '))
          } else {
            data.lastname = displayName
          }
          await store.dispatch('profile/updateUserData', data) // update store
          await db.collection('users').doc(user.uid).set(Object.assign({}, data), { merge: true })
        }
      }
    })
    console.log(`checking existing user and load/initialize profile: ${Date.now() - start}ms`)
  }

  // remove loading spinner
  const spinner = document.getElementById('lds-overlay')
  if (spinner) spinner.remove()
})
